import { Trans } from '@lingui/react'
import { type FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './RedeemRedPoints.scss'
import {
  addRedPointsAction,
  deleteRedPointsAction,
} from 'shared/store/ducks/cart/cart'
import { type IState } from 'types/redux/store'
import Button from 'views/components/atoms/Button'
import IconTick from 'views/components/atoms/Icon/IconTick'
import LoadingIndicator from 'views/components/atoms/LoadingIndicator'

const calcButtonStyle = (
  reqLoad: boolean,
  isSelected: boolean,
  selectedRedPoints: number
) => {
  let buttonStyle = reqLoad ? 'buttonLoad' : 'buttonGhost'

  if (isSelected && selectedRedPoints !== 0) {
    buttonStyle = 'buttonAccepted'
  }

  return buttonStyle
}

interface RedPointsSubmitButtonProps {
  selectedRedPoints: number
  redPointsPreviousAmount: number
  hasSAEGroup: boolean
}

const RedPointsSubmitButton: FC<RedPointsSubmitButtonProps> = ({
  selectedRedPoints,
  redPointsPreviousAmount,
  hasSAEGroup,
}) => {
  const dispatch = useDispatch()
  // @ts-ignore
  const loading = !!useSelector((state: IState) => state.cart.redPointsLoad)

  const isSelected = selectedRedPoints === redPointsPreviousAmount

  return (
    <Button
      className="o-RedeemRedPoints__button"
      name="cart-redPointsBox-submit"
      // @ts-ignore
      style={calcButtonStyle(loading, isSelected, selectedRedPoints)}
      onClick={() => {
        if (!loading) {
          if (selectedRedPoints === 0) {
            dispatch(deleteRedPointsAction())
          } else {
            // Note that the button is disabled if selectedRedPointsInCart is true
            dispatch(addRedPointsAction(selectedRedPoints))
          }
        }
      }}
      disabled={isSelected || !hasSAEGroup}
    >
      {loading ? (
        <LoadingIndicator color="white" />
      ) : (
        <>
          {isSelected && selectedRedPoints !== 0 ? (
            <IconTick />
          ) : (
            <Trans id="cart.redPointsBox.button.label" />
          )}
        </>
      )}
    </Button>
  )
}

export default RedPointsSubmitButton
